import AppContext from '@/types/context'
import Gallery from '@/elements/widgets/Gallery/Gallery'
import styles from './GalleryInline.module.scss'
import GalleryLabel from '@/components/GalleryLabel/GalleryLabel'

const GalleryInline = ({ item, context }: { item: any; context: AppContext }) => {
  const gallery = item.items?.filter((child: any) => child.type === 'gallery')[0]

  if (!item?.items || !gallery) {
    return null
  }

  return (
    <div className={styles.wrapper}>
      <Gallery item={item} context={context} variant="inline" />
      <div className={styles['text-container']} data-cy="text-container">
        <GalleryLabel count={(item?.items?.length ?? 1) - 1} />
        <h2 className={styles.headline}>{gallery?.model?.headline}</h2>
      </div>
    </div>
  )
}

export default GalleryInline
